module.exports = __webpack_public_path__ + "img/ico-bell-ring-outline-grey.be1f61bf.svg";